import gql from "graphql-tag";
const Notificationquery = gql`
  query notificationQuery($username: String!) { getNotification(username: $username) { notifications{ id message action_url added_by added_on __typename }  __typename  } __typename}
`;
export default Notificationquery;
